type mockOption = {
  id: string;
};

export const getNextSerialId = (options: mockOption[]): string => {
  if (options.length === 0) return "1";

  const maxId = Math.max(...options.map((opt) => Number(opt.id)));
  return String(maxId + 1);
};

const assetBaseUrls = {
  audio: "https://lams-assets.s3.us-east-1.amazonaws.com/audio",
  video: "https://lams-assets.s3.us-east-1.amazonaws.com/video",
  graphic: "https://lams-assets.s3.us-east-1.amazonaws.com/graphics",
} as const;

const extensions = {
  audio: "mp3",
  video: "mp4",
  graphic: "png",
} as const;

export const getAssetUrl = (
  assetType: keyof typeof assetBaseUrls,
  assetCode: string
): string =>
  `${assetBaseUrls[assetType]}/${assetCode}.${extensions[assetType]}`;
